import { DerivativesGroupType } from 'common/api/autogenerated/trading-gateway';

import { GroupsHashMap } from 'common/types';

export const excludedGroupsForDesktop: DerivativesGroupType[] = [
  DerivativesGroupType.LOSERS,
  DerivativesGroupType.GAINERS,
  DerivativesGroupType.TWENTY_FOUR_HVOL,

  // 85523 TEMP CODE
  DerivativesGroupType.CRYPTO_MARGINED,
];

export const excludedGroupsForMobile: DerivativesGroupType[] = [
  DerivativesGroupType.ALL,

  // 85523 TEMP CODE
  DerivativesGroupType.CRYPTO_MARGINED,
];

export const LINEAR_PNL_DIGITS = 2;
export const INVERSED_PNL_DIGITS = 4;

export const LINEAR_FEE_DIGITS = 2;
export const INVERSED_FEE_DIGITS = 6;

export const groupsForMobile = (groups: GroupsHashMap) => {
  const result = { ...groups };

  excludedGroupsForMobile.forEach((x) => x in result && delete result[x]);

  if (groups.Favorites) groups.Favorites.label = '';

  return result;
};
export const groupsForDesktop = (groups: GroupsHashMap) => {
  const result = { ...groups };

  excludedGroupsForDesktop.forEach((x) => x in result && delete result[x]);

  return result;
};
